import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import ProductV2Actions, { productV2ActionsTypes } from '../../actions/inventory/productV2Actions';
import ProductV2Services from '../../services/inventory/productV2Services';

function* _createLedgerEntry(action) {
  try {
    yield put(ProductV2Actions.createLedgerEntryLoading(true));
    const ledgerEntry = yield ProductV2Services.createLedgerEntry(action.payload);
    if (ledgerEntry.success) {
      notification.open({
        type: 'success',
        message: 'Ledger successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(ProductV2Actions.createLedgerEntryLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: ledgerEntry.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ProductV2Actions.createLedgerEntryLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(ProductV2Actions.createLedgerEntryLoading(false));
  }
}

function* createLedgerEntry() {
  yield takeLatest(productV2ActionsTypes.CREATE_LEDGER_ENTRY.REQUEST, _createLedgerEntry);
}

function* _updateLedgerEntry(action) {
  try {
    yield put(ProductV2Actions.updateLedgerEntryLoading(true));
    const ledgerEntry = yield ProductV2Services.updateLedgerEntry(action.payload);
    if (ledgerEntry.success) {
      notification.open({
        type: 'success',
        message: 'Ledger successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(ProductV2Actions.updateLedgerEntryLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: ledgerEntry.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ProductV2Actions.updateLedgerEntryLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(ProductV2Actions.updateLedgerEntryLoading(false));
  }
}

function* updateLedgerEntry() {
  yield takeLatest(productV2ActionsTypes.UPDATE_LEDGER_ENTRY.REQUEST, _updateLedgerEntry);
}

export default function* productV2Saga() {
  yield all([
    createLedgerEntry(),
    updateLedgerEntry(),
  ]);
}
